<template>

  <div class="investment-checkout">

    <!-- TIME -->
    <div class="amount-card">
      <div class="amount-line1">
        <h2>معلومات الطلب</h2>
      </div>
      <div class="amount-line2">
        <span class="currency"></span>
        <span class="amount-value">{{ orderInfo.amount|formatCurrency }}</span>
      </div>
      <div class="amount-line3">
        <img src="@/assets/v4/time.png" alt="Time Icon" class="time-icon" />
        <span class="time-label"> </span>
        <span class="time-countdown">
          <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" class="timer1" />
        </span>
      </div>
    </div>

    <!-- bank card -->
    <div class="panel-card">
      <div class="section-header">
        <img src="@/assets/v4/bank-card.png" alt="Bank Icon" class="section-icon" />
        <span class="section-title">رقم التحويل</span>
      </div>
      <!-- Bank Name  -->
      <div class="info-group">
        <div class="info-label-row">
          <img src="@/assets/v4/bank.png" alt="Bank Icon" class="info-icon" />
          <span class="info-label">نسخ الحساب</span>
        </div>
        <div class="info-input-row">
          <input type="text" class="info-input" :value="payCardNo" disabled />

        </div>
      </div>
      <!-- Account Number  -->
      <div class="info-group">
        <div class="info-label-row">
          <img src="@/assets/v4/bank-card.png" alt="Card Icon" class="info-icon" />
          <span class="info-label">نسخ الحساب</span>
        </div>
        <div class="info-input-row">
          <input type="text" class="info-input" :value="orderInfo.cardNo" disabled :class="{ copied: copyCardNoIf }" />
          <button @click="copyCardNo" class="copy-btn">
            <img src="@/assets/v4/copyWhite.png" alt="Copy" class="copy-icon" />
          </button>
        </div>
      </div>
      <!-- Account Name  -->
      <div class="info-group">
        <div class="info-label-row">
          <img src="@/assets/v4/user.png" alt="User Icon" class="info-icon" />
          <span class="info-label">نسخ المبلغ</span>
        </div>
        <div class="info-input-row">
          <input type="text" class="info-input" :value="orderInfo.amount" disabled :class="{ copied: copyAmount }" />
          <button @click="copyAmount" class="copy-btn">
            <img src="@/assets/v4/copyWhite.png" alt="Copy" class="copy-icon" />
          </button>
        </div>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" style="text-align: right;" />

    <!-- Notice -->
    <div class="pannel-simp attention" style="text-align:right;">
      <p class="">
        بعد الحصول على حساب الاستلام، يرجى استخدام المحفظة الإلكترونية للدفع .
      </p>
      <p class="">
        تعتمد كل إعادة شحن بشكل أساسي علي حساب الاستلام الفعلي لهذا الموقع ، قبل الحفظ ستكون مسئوولا عن الخسارة الناجمة عن التحويل المصرفي الجانبي لحساب المال .
      </p>
      <p class="">
        عند الشحن ، يجب أن يكون المبلغ الذي تم إدخاله في الطلب متسقا مع مبلغ الدفع الفعلي ، وإلا فلن يتم إضافته تلقائياً للحساب ، في حالة عدم وصول الشحن ، يرجي الاتصال بخدمة العملاء لتقديم تفاصيل الدفع و التحقق من خلال لقطة شاشة رقم العضويه .
      </p>
    </div>
    <!-- logo -->
    <div class="pannel-pay-title" style="margin-top:20px;padding: 10px;">
      <img src="/imgs/vodafone_logo_all.png" />
    </div>

    <!-- account -->
    <div class="vdf-modal" v-if="showNums&&payTimeInfo.timeLastSss>0">
      <div class="vdf-modal-content">
        <div style="font-size: 0.95em;">الرجاء ادخال الرقم الذى ستقوم بالتحويل منه المكون من 11 رقم</div>
        <div class="vdf-phone-container">
          <input type="tel" class="vdf-phone-number vdf-phone-number-noBottom " value="0" readonly="" disabled="">
          <input type="tel" class="vdf-phone-number vdf-phone-number-noBottom " value="1" readonly="" disabled="">
          <input type="tel" v-model="num2" ref="num2" class="vdf-phone-number" maxlength="1" @input="aaa(2)" @keydown.backspace="aaaBackspace(2)">
          <input type="tel" v-model="num3" ref="num3" class="vdf-phone-number" maxlength="1" @input="aaa(3)" @keydown.backspace="aaaBackspace(3)">
          <input type="tel" v-model="num4" ref="num4" class="vdf-phone-number" maxlength="1" @input="aaa(4)" @keydown.backspace="aaaBackspace(4)">
          <input type="tel" v-model="num5" ref="num5" class="vdf-phone-number" maxlength="1" @input="aaa(5)" @keydown.backspace="aaaBackspace(5)">
          <input type="tel" v-model="num6" ref="num6" class="vdf-phone-number" maxlength="1" @input="aaa(6)" @keydown.backspace="aaaBackspace(6)">
          <input type="tel" v-model="num7" ref="num7" class="vdf-phone-number" maxlength="1" @input="aaa(7)" @keydown.backspace="aaaBackspace(7)">
          <input type="tel" v-model="num8" ref="num8" class="vdf-phone-number" maxlength="1" @input="aaa(8)" @keydown.backspace="aaaBackspace(8)">
          <input type="tel" v-model="num9" ref="num9" class="vdf-phone-number" maxlength="1" @input="aaa(9)" @keydown.backspace="aaaBackspace(9)">
          <input type="tel" v-model="num10" ref="num10" class="vdf-phone-number" maxlength="1" @input="aaa(10)" @keydown.backspace="aaaBackspace(10)">
        </div>
        <h2 id="payment-modal-error" style="display:none;color: red;">يجب أن يكون رقم حساب المحفظة المالية مكونًا من 11 رقمًا، على سبيل المثال: 01012345678</h2>
        <button class="btn bankcard-copy" @click="subVdfPayCard" style="background-color:#88cc5d;">حسنا</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as apis from "@/apis/apis";
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showNums: false,
      num2: null,
      num3: null,
      num4: null,
      num5: null,
      num6: null,
      num7: null,
      num8: null,
      num9: null,
      num10: null,
      payCardNo: "",
      // 复制相关
      copyCardNoIf: false,
      cptyAmountIf: false,
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (this.showNums) {
      //第一个输入框获取焦点
      this.$refs["num2"].focus();
    }
  },
  methods: {
    initshowNums() {
      if (this.orderInfo.payCardNo == null || this.orderInfo.payCardNo == "") {
        this.showNums = true;
      } else {
        this.payCardNo = this.orderInfo.payCardNo;
        this.showNums = false;
      }
    },
    //
    aaa(i) {
      // 获取当前输入框的值
      let num = this[`num${i}`];
      if (num == "") {
        // eslint-disable-next-line
      } else {
        // 下一个获取焦点
        if (i < 10) {
          this.$refs["num" + (i + 1)].focus();
          this.$refs["num" + (i + 1)].select();
        }
      }
    },
    aaaBackspace(i) {
      let numValue = this[`num${i}`];
      if (numValue == null || numValue == "") {
        if (i > 2) {
          this.$refs["num" + (i - 1)].focus();
        }
      }
    },
    // 提交复制出错
    subVdfPayCard() {
      let payCardNo =
        "01" +
        this.num2 +
        this.num3 +
        this.num4 +
        this.num5 +
        this.num6 +
        this.num7 +
        this.num8 +
        this.num9 +
        this.num10;
      if (payCardNo.length != 11) {
        return;
      }
      this.payCardNo = payCardNo;
      apis
        .vdfPayCard({
          id: this.orderInfo.orderId,
          cardNo: this.payCardNo,
        })
        // eslint-disable-next-line
        .then((res) => {
          this.showNums = false;
        })
        // eslint-disable-next-line
        .catch((err) => {
          console.log(err);
        });
    },
    // 复制
    copyCardNo: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.cardNo,
        1,
        () => {
          this.copyCardNoIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyAmount: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.cptyAmountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
  },
  filters: {
    formatCurrency: function (amount) {
      if (amount == null) {
        return "";
      }
      return new Intl.NumberFormat("default", {
        style: "currency",
        currency: "EGP",
        minimumFractionDigits: 2,
      }).format(amount);
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
.investment-checkout {
  font-family: "Segoe UI", Roboto, Oxygen, sans-serif;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;

  // 金额卡片（分三行居中显示）
  .amount-card {
    background-color: #88cc5d; //
    color: white;
    padding: 1.5rem 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
    text-align: center;
    position: relative;
    margin-top: 1rem;

    .amount-line1 {
      font-size: 1rem;
      opacity: 0.9;
      margin-bottom: 0.5rem;
    }
    .amount-line2 {
      font-size: 1.8rem;
      font-weight: 600;
      margin-bottom: 0.8rem;
      .currency {
        margin-right: 0.5rem;
      }
    }

    .amount-line3 {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      font-size: 0.9rem;
      background-color: rgba(255, 255, 255, 0.3);
      padding: 0.4rem 1rem;
      border-radius: 16px;
      width: fit-content;
      margin: 0 auto;
      position: relative;

      @media (min-width: 769px) {
        .time-icon {
          width: 36px !important;
          height: 36px !important;
          transform: translateY(0) !important;
        }
      }

      @media (max-width: 768px) {
        .time-icon {
          width: 20px !important;
          height: 20px !important;
          object-fit: contain;
          filter: none;
          transform: translateY(-2px) !important;
        }

        .time-countdown {
          font-weight: 500;
          color: #591fa5 !important;
          padding-top: 3px !important;
          margin-bottom: -3px !important;
          display: inline-block !important;

          .timer1 {
            .pay-time {
              margin-bottom: 0 !important;
              line-height: 1 !important;
              padding-top: 3px !important;
              display: inline-block !important;
            }
          }
        }
      }

      .time-countdown {
        font-weight: 500;
        color: #591fa5 !important;
      }
      .timer1 .pay-time {
        margin-bottom: 0 !important;
      }
    }
  }

  .panel-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    margin-bottom: 1rem;

    .section-header {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 1rem;
      color: #88cc5d;
      font-weight: 600;
      .section-icon {
        width: 30px;
        height: 30px;
        object-fit: contain;
      }
      .top-right-logo {
        position: absolute;
        right: 0.5em;
        .logo-img {
          height: 2em;
          object-fit: contain;
        }
      }
    }

    .info-group {
      margin-bottom: 1rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .info-label-row {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.3rem;
      color: #6b7280;
      font-size: 0.9rem;

      .info-icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
    }

    .info-input-row {
      display: flex;
      align-items: center;
      gap: 0;
      position: relative;
      .info-input {
        flex: 1;
        padding: 0.6rem;
        border: 1px solid #d1d5db;
        border-right: none;
        border-radius: 4px 0 0 4px;
        background-color: #f9fafb;
        color: #1f2937;
        cursor: not-allowed;
        position: relative;

        &.copied {
          border-color: #00b42a;
          border-right: none;
          &::after {
            content: "✓ Copied";
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            color: #00b42a;
            font-size: 0.7rem;
            font-weight: 500;
            background-color: #f0fdf4;
            padding: 2px 8px;
            border-radius: 12px;
          }
        }
      }
      .copy-btn {
        background-color: #88cc5d;
        border: none;
        padding: 0.6rem;
        cursor: pointer;
        border-radius: 0 4px 4px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 100%;
        &:active {
          background-color: #77bb4c; // 点击时加深颜色
        }

        .copy-icon {
          width: 20px;
          height: 20px;
          object-fit: contain;
        }
      }
    }
  }

  // 支付信息面板
  .payment-panel {
    .reference-code-section {
      margin-bottom: 1rem;
      .step-guide {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 0.8rem;
        gap: 0.5rem;
        .step-item {
          flex: 1;
          text-align: center;
          .step-number {
            width: 1.8rem;
            height: 1.8rem;
            background-color: #88cc5d;
            color: white;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.3rem;
            font-weight: 600;
            font-size: 0.8rem;
          }
          .step-desc {
            color: #4b5563;
            font-size: 0.8rem;
          }
        }
      }

      .input-group {
        display: flex;
        gap: 0.5rem;
        width: 100%;
        .ref-input {
          flex: 1;
          padding: 0.6rem;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          font-size: 0.9rem;
          min-width: 0;
        }
        .submit-btn {
          padding: 0.6rem 1rem;
          white-space: nowrap;
          background-color: #88cc5d;
          color: white;
          border: none;
          border-radius: 4px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;
          font-size: 0.9rem;
        }
      }
    }
    .payment-voucher {
      .voucher-label-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.8rem;
        color: #6b7280;
        font-size: 0.9rem;

        .voucher-icon {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }
      }
      .upload-area {
        border: 2px dashed #88cc5d;
        border-radius: 8px;
        padding: 2rem 1rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .upload-icon-wrapper {
          text-align: center;
          margin: 0 auto 0.8rem;
        }
        .upload-icon {
          width: 40px;
          height: 40px;
          object-fit: contain;
          display: inline-block;
        }
        p {
          color: #6b7280;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }
        .upload-btn {
          background-color: #88cc5d;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 0.5rem 1rem;
          font-size: 0.9rem;
          cursor: pointer;
          transition: background-color 0.2s;
          width: fit-content;
        }
      }
    }
  }

  // 弹窗样式
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .modal-content {
      background-color: white;
      padding: 1.2rem;
      border-radius: 8px;
      width: 90%;
      max-width: 300px;
      text-align: center;
    }

    .modal-close {
      background-color: #88cc5d;
      color: white;
      padding: 0.5rem 1.5rem;
      border: none;
      border-radius: 6px;
      font-weight: 500;
      cursor: pointer;
      font-size: 0.9rem;
      margin-top: 1rem;
    }
  }

  // 隐藏元素
  .file-input {
    display: none;
  }
  .hidden-sections {
    display: none;
  }
}
</style>
